<template>
  <div class="main">
    <el-form :inline="true">
      <!--      <el-form-item label="学校名称：">-->
      <!--        <el-input v-model="query.school_name" placeholder="请输入学校名称"></el-input>-->
      <!--      </el-form-item>-->
      <!--      <el-form-item label="简历来源：">-->
      <!--        <el-select v-model="query.channel">-->
      <!--          <el-option label="全部" value></el-option>-->
      <!--          <el-option label="习讯云" value="school"></el-option>-->
      <!--          <el-option label="小程序" value="xcx"></el-option>-->
      <!--          <el-option label="公众号" value="woa"></el-option>-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->
      <el-form-item label="投递状态：">
        <el-select v-model="query.apply_status">
          <el-option label="全部" value></el-option>
          <el-option label="待处理" value="student"></el-option>
          <!-- <el-option label="学校审核通过" value="school_passed"></el-option>
          <el-option label="学校审核不通过" value="school_refused"></el-option> -->
          <el-option label="已录用" value="enterprise_passed"></el-option>
          <el-option label="不合适" value="enterprise_refused"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <ul class="resume">
      <!-- <ul class="resume" v-if="$store.state.paymentStatus"> -->
      <div class="auth" v-if="total == 0">暂无简历投递！</div>
      <li v-for="item in resumes" :key="item.apply_id">
        <div class="left-content">
          <img src="../../../assets/img/resume/profile-photo.png" alt />
          <div class="base-info">
            <div class="line-1">
              <strong>{{item.student_name}}</strong>
              <span>{{item.job_name}}</span>
              <!--               <span style="color: #0bb5ff;">（简历状态：{{item.applyStatus}}）</span>-->
            </div>
            <div class="line-2">
              <span>{{item.created_at}}</span>
              <span>{{item.school_name}}</span>
              <span>{{item.major_name || '专业信息未填写'}}</span>
              <span>{{item.graduation_year ? `${item.graduation_year}届` : '毕业时间未填写'}}</span>
              <span>{{item.phone}}</span>
            </div>
          </div>
        </div>
        <div class="right-content">
          <!--          <div v-if="item.phone == '联系方式在校企合作页面缴费后可见'">-->
          <!--            <el-button type="primary" size="mi" @click="auth(item.school_id)">马上认证</el-button>-->
          <!--          </div>-->
          <!--          <div class="handle-btn" v-else-if="pending.indexOf(item.apply_status) !== -1">-->
          <!--            <span class="edit-btn" @click="edit(item.apply_id, 'enterprise_passed')">录用</span>-->
          <!--            <span class="edit-btn" @click="edit(item.apply_id, 'enterprise_refused')">不合适</span>-->
          <!--          </div>-->
          <!--          <div v-else>{{item.applyStatus}}</div>-->

          <div class="handle-btn">
            <el-button
              type="primary"
              :disabled="item.status == 'enterprise_passed'"
              @click="pass(item.id)"
            >通过</el-button>
            <el-button
              type="primary"
              :disabled="item.status == 'enterprise_refused'"
              @click="noPass(item.id)"
            >不合适</el-button>
            <el-button
              type="info"
              @click="look(item.student_id,item.student_name,item.school_id)"
            >查看</el-button>
          </div>
        </div>
      </li>
    </ul>
    <!-- <div class="auth" v-else>
      <div v-if="total == 0">暂无简历投递！</div>
      <div v-else>已有{{total}}位学生向您投递了简历，认证后可见，请点击<span @click="$router.push('/pay')">立即认证</span>！</div>
    </div>-->
    <Pagination
      ref="pagination"
      :total="total"
      @size-change="getResumes"
      @current-change="getResumes"
    />

    <!-- 个人简历弹框 -->
    <el-dialog :title="selfResume.name+'的简历'" :visible.sync="detailDialogVisible" width="500px">
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">姓名：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">学校：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.school_name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">专业：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.major_name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">毕业年份：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.graduation_Year }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">性别：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.gender == 1?'男':'女' }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">民族：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.nation }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">籍贯：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.native_province + selfResume.native_city }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">出生日期：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.birthday }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">联系电话：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.phone }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">联系QQ：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.qq }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">当前所在城市：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.current_province + selfResume.current_city }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望城市1：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_city1 }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望城市2：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_city2 }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望工作岗位：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_job }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望最低薪资：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_low }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">期望最高薪资：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.expect_high }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">校内职务：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.post }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">获得的资格证书：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.certificate }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">技能大赛获奖说明：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.prise }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div style="text-align: right;">校内其他获奖荣誉：</div>
        </el-col>
        <el-col :span="10">
          <div>{{ selfResume.other_prise }}</div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/pagination"; // 分页组件
import formatter from "@/assets/js/mixins/formatter"; // 公用函数

export default {
  components: {
    Pagination
  },
  mixins: [formatter],
  data() {
    return {
      query: {
        // 查询条件
        // channel: "", // 简历来源
        apply_status: "" // 投递状态
        // school_name: '', // 学校名称
      },
      resumes: [], // 简历
      total: 0,
      pending: ["student", "school_passed", "school_refused"], // 待处理状态
      detailDialogVisible: false, // 详情对话框是否显示
      selfResume: {
        birthday: "",
        certificate: "",
        current_city: "",
        current_province: "",
        expect_city1: "",
        expect_city2: "",
        expect_city3: "",
        expect_high: "",
        expect_job: "",
        expect_low: "",
        expect_province1: "",
        expect_province2: "",
        expect_province3: "",
        family: "",
        family_phone: "",
        gender: 1,
        graduation_Year: "",
        major_name: "",
        name: "",
        nation: "",
        native_city: "",
        native_province: "",
        other_prise: "",
        phone: "",
        post: "",
        prise: "",
        qq: "",
        school_name: ""
      } //个人简历
    };
  },
  mounted() {
    this.getResumes();
  },
  methods: {
    async getResumes() {
      let params = this.delNullVal(this.query);
      params.page = this.$refs.pagination.page;
      params.page_size = this.$refs.pagination.page_size;
      let res = await this.$api.job.getPlatformResume(params);
      if (res.code === 0) {
        this.resumes = res.data.data.map(item => {
          item.applyStatus = this.formatApplyStatus(item.apply_status);
          return item;
        });
        this.total = res.data.total;
      }
    },
    search() {
      this.$refs.pagination.page = 1;
      this.getResumes();
    },
    async edit(operateId, apply_status) {
      let params = {
        apply_status
      };
      let res = await this.$api.job.updateDeliver1(operateId, params);
      if (res.code === 0) {
        this.$message.success("成功！");
        this.getResumes();
      }
    },
    async pass(id) {
      let params = {
        status: "enterprise_passed"
      };
      let res = await this.$api.job.updatePlatformResume(id, params);
      if (res.code === 0) {
        this.$message.success("成功！");
        this.getResumes();
      }
    },
    async noPass(id) {
      let params = {
        status: "enterprise_refused"
      };
      let res = await this.$api.job.updatePlatformResume(id, params);
      if (res.code === 0) {
        this.$message.success("成功！");
        this.getResumes();
      }
    },
    async look(stuId, name, schoolId) {
      // if (!this.$store.state.paymentStatus) {
      //   this.$confirm(
      //     '<p style="color:#606266">未认证状态下不能查看简历，是否马上去认证</p>',
      //     "提示",
      //     {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       dangerouslyUseHTMLString: true,
      //       type: "warning"
      //     }
      //   )
      //     .then(() => {
      //       this.auth(schoolId);
      //     })
      //     .catch(() => {
      //       this.$message({
      //         type: "info",
      //         message: "已取消认证"
      //       });
      //     });
      //   return;
      // }
      let params = {
        student_id: stuId,
        student_name: name,
        school_id: schoolId
      };
      let res = await this.$api.job.getStuResume(params);
      if (res.code === 0) {
        // this.$message.success("成功！");
        // this.getResumes();
        let data = res.data;
        this.selfResume.birthday = data.birthday;
        this.selfResume.certificate = data.certificate;
        this.selfResume.current_city = data.current_city;
        this.selfResume.current_province = data.current_province;
        this.selfResume.expect_city1 = data.expect_city1;
        this.selfResume.expect_city2 = data.expect_city2;
        this.selfResume.expect_city3 = data.expect_city3;
        this.selfResume.expect_high = data.expect_high;
        this.selfResume.expect_job = data.expect_job;
        this.selfResume.expect_low = data.expect_low;
        this.selfResume.expect_province1 = data.expect_province1;
        this.selfResume.expect_province2 = data.expect_province2;
        this.selfResume.expect_province3 = data.expect_province3;
        this.selfResume.family = data.family;
        this.selfResume.family_phone = data.family_phone;
        this.selfResume.gender = data.gender;
        this.selfResume.graduation_Year = data.graduation_Year;
        this.selfResume.major_name = data.major_name;
        this.selfResume.name = data.name;
        this.selfResume.nation = data.nation;
        this.selfResume.native_city = data.native_city;
        this.selfResume.native_province = data.native_province;
        this.selfResume.other_prise = data.other_prise;
        this.selfResume.phone = data.phone;
        this.selfResume.post = data.post;
        this.selfResume.prise = data.prise;
        this.selfResume.qq = data.qq;
        this.selfResume.school_name = data.school_name;

        this.detailDialogVisible = true;
      }
    },
    auth(schoolId) {
      this.pushRouter("/pay", {
        pay_subject: "school",
        school_id: schoolId
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/base.scss";

.main {
  .resume {
    margin-top: 24px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0px 1px 16px 0px #d2d2d2;
      border-radius: 24px;
      padding: 24px 16px;
      color: #929292;
      margin-bottom: 20px;
      .left-content {
        display: flex;
        align-items: center;
        img {
          flex-grow: 0;
          width: 57px;
          height: 57px;
        }
        .base-info {
          line-height: 26px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 20px;
          color: #929292;
          .line-1 {
            strong {
              color: #000;
              margin-right: 20px;
            }
          }
          .line-2 {
            span:not(:last-child) {
              &::after {
                content: "";
                display: inline-block;
                width: 2px;
                height: 14px;
                background: #929292;
                margin: 0 20px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .right-content {
        min-width: 200px;
        text-align: center;
        .edit-btn {
          display: inline-block;
          width: 73px;
          height: 31px;
          margin-right: 10px;
          text-align: center;
          line-height: 31px;
          background: rgba(59, 163, 240, 1);
          border-radius: 9px;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
  .auth {
    height: 100px;
    text-align: center;
    padding: 100px 0;
    span {
      color: $blue;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>